<template>
  <Layout>
    <Loader :loading="loadingExport" no-axios>
      <div class="">
        <div class="title">{{ lodash.upperCase(title) }}</div>
        <div v-if="!lodash.isEmpty(filterColumns)">
          <model-filter
            v-model="filter"
            :columns="filterColumns"
            :modelVariable="modelVariable"
            :filterHandler="filterHandler"
          />
        </div>
      </div>
      <!-- <div class="title">{{ lodash.upperCase($t("List")) }} {{ lodash.upperCase(title) }}</div> -->
      <div class="row">
        <model-index
          ref="table"
          class="col-12"
          :loading="loading"
          v-bind="$props"
          :columns="columns"
          :busy.sync="busy"
          :models-paginated="modelsPaginated"
          :page.sync="page"
          :per-page.sync="perPage"
          :from="from"
          :total="totalFiltered"
          :search.sync="search"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :filter-params.sync="filterParams"
          @create-click="handleCreate"
          @export-click="handleExport"
          @show-click="handleShow"
          @edit-click="handleEdit"
          @delete-click="handleDelete"
        >
        </model-index>
      </div>
      <approval-template-activate-confirmation
        ref="activateConfirmationModal"
        @confirmed="handleActivateConfirmed"
        @cancelled="handleActivateCancelled"
      />
    </Loader>
  </Layout>
</template>
<script>
import ModelIndex from "../models/index-v3"
import ApprovalTemplateActivateConfirmation from "@/components/modals/approval-template-activate-confirmation"

export default {
  extends: ModelIndex,
  components: {
    ApprovalTemplateActivateConfirmation,
  },
  page: {
    title: "Approval Templates",
  },
  props: {
    cardTitle: {default() { return this.lodash.upperCase(`${this.$t("List")} ${this.$t('approval_templates.plural')}`) } },
    resourceRoute: {default: 'approval_templates'},
    modelVariable: {default: 'approval_template'},
    denyCreate: { type: Boolean, default() { return !this.$auth.hasPermissionTo('approval_rules.create') } }
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('approval_templates.plural')),
      items: [
        {
          text: this.lodash.upperFirst(this.$t('approval_templates.plural')),
          href: "/approval_templates",
          active: true,
        },
      ],
      togglingId: null,
      checkboxResetKey: 0,

    }
  },
  computed: {
    columns() {
      const vm = this
      return {
        ['approval_template']: [
          { key: 'index', label: 'No', sortable: false, style: { width: '1%' } },
          {
            key: 'name',
            label: this.lodash.startCase(this.$t('approval_templates.name')),
            thStyle: { minWidth: '125px' },
            sortable: true
          },
          {
            key: 'approvable_type',
            label: this.lodash.startCase(this.$t('approval_templates.approvable_type')),
            thStyle: { minWidth: '175px' },
            formatter: (value) => this.getApprovableTypeLabel(value)
          },
          {
            key: 'approval_template_steps_count',
            label: this.lodash.startCase(this.$t('approval_templates.approval_template_steps_count')),
            thStyle: { minWidth: '200px' },
            formatter: (value, key, item) => {
              if (item && Array.isArray(item.approval_template_steps)) {
                const levels = new Set(item.approval_template_steps.map(s => s.level).filter(l => l != null));
                return levels.size;
              }
              return value;
            }
          },
          {
            key: 'is_active',
            label: this.lodash.startCase(this.$t('approval_templates.status')),
            thStyle: { minWidth: '125px' },
            component: {
              props: ['item'],
              computed: {
                isLoading() { return vm.togglingId === this.item.id },
                resetKey() { return vm.checkboxResetKey }
              },
              methods: {
                toggle(newValue) { vm.toggleIsActive(this.item, newValue) }
              },
              template: `
                <div>
                  <b-form-checkbox :key="item.id + '-' + resetKey" :checked="!!item.is_active" name="check-button" switch :disabled="isLoading || !!item.is_active" @change="toggle">
                    <span v-if="item.is_active">{{ $t('approval_templates.active') }}</span>
                    <span v-else>{{ $t('approval_templates.inactive') }}</span>
                  </b-form-checkbox>
                </div>
              `
            }
          },
          { key: 'action', label: this.$t('Action'), class: 'text-center', style: { width: '1%' } }
        ],
      };
    },
  },
  methods: {
    getApprovableTypeLabel(type) {
      const typeMap = this.$t('approval_templates.approvable_types');
      return typeMap[type] || type;
    },
    toggleIsActive(item, newValue) {
      if (newValue) {
        this.togglingId = item.id
        this.$refs.activateConfirmationModal.show(item)
        return
      }
      this.performToggleIsActive(item, newValue)
    },
    handleActivateConfirmed(item) {
      this.performToggleIsActive(item, true)
    },
    handleActivateCancelled() {
      this.togglingId = null
      this.checkboxResetKey++
    },
    performToggleIsActive(item, newValue) {
      this.togglingId = item.id
      this.$axios.put(`/approval_templates/${item.id}`, { is_active: newValue })
        .then((response) => {
          Object.assign(item, response.data.data)
          if (newValue) {
            this.$toast(this.$t('approval_templates.messages.activate_success', { name: item.name }), { type: 'success' })
            this.$refs.table.$refs.table.refresh()
          }
        })
        .catch((error) => {
          this.checkboxResetKey++
          this.failedAlert(error)
        })
        .finally(() => { this.togglingId = null })
    },
    delete(value) {
      return this.$axios.delete(`/approval_templates/${this.getModelKey(value)}`)
    },
    modelPolicy() {
      return {
        _denyShow: !this.$auth.hasPermissionTo('approval_rules.view'),
        _denyEdit: !this.$auth.hasPermissionTo('approval_rules.edit'),
        _denyDelete: !this.$auth.hasPermissionTo('approval_rules.delete'),
      }
    },
    fetchModels(page = 1) {
      return this.$axios.get('/approval_templates', {
        params: {
          // with: 'customer,bank',
          with: 'approval_template_steps',
          page: page,
          per_page: this.perPage,
          search: this.search,
          sort: `${this.sortBy === 'name' ? 'id':this.sortBy},${(this.sortDesc || this.sortBy === 'name') ? 'desc' : 'asc'}`,
          ...this.filterParams
        }
      }).then((response) => {
        const { data: { data, meta } } = response;
        this.models = data.map((datum) => {
          const steps = datum.approval_template_steps || [];
          const uniqueLevels = new Set(steps.map((s) => s.level).filter((l) => l != null));
          return {
            ...datum,
            approval_template_steps_count: uniqueLevels.size,
            ...this.modelPolicy(),
          };
        });
        this.page = Number(meta.current_page);
        this.perPage = Number(meta.per_page);
        this.from = Number(meta.from);
        this.total = Number(meta.total);

        this.stats = [
          {
            title: this.lodash.upperFirst(this.$t('approval_templates.count')),
            value: this.$numeral(this.total).format('0,0 a'),
            valueTitle: this.$numeral(this.total).format('0,0'),
            icon: 'bx bx-user'
          },
        ]

        return response;
      }).catch((error) => this.failedAlert(error));
    }
  },
};
</script>
